import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { CustomIconsService } from './services/custom-icons.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    HttpClientModule,
  ],
  providers: [
    CustomIconsService,
  ]
})
export class CustomIconsModule { }
